/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// redux utils
import { createSlice } from '@reduxjs/toolkit';
import { history, environment } from '@insticator/insticator-ui';
// utils
import {
    isAfterFourPM,
    getDateNYC,
    zeroPadding,
} from '@insticator/insticator-ui';
import {datetoAPIString, daysPreviously} from '../../utils/date';

// helpers
const generateDefaultStartDate = () => {
    let week = new Date(getDateNYC() - (isAfterFourPM() ? daysPreviously(7) : daysPreviously(8)));
    return datetoAPIString(week);
};

const generateDefaultEndDate = () => {
    let today = new Date(getDateNYC() - (isAfterFourPM() ? daysPreviously(1) : daysPreviously(2)));
    return datetoAPIString(today);
};


/* ========== ~~~~~~~~~~ APP STATUS SLICE : REDUCER ~~~~~~~~~~ ========== */
const getInitialState = () => ({
    currentPage: window.location.pathname,
    currentMenu: null,
    sidebarOpen: true,
    sidebarLocked: true,
    userMenuOpen: false,
    environment,
    filters: {
        dateRange : {
            to: generateDefaultEndDate(),
            from: generateDefaultStartDate(),
            shortcut: 'Last 7 Days'
        },
        sites: [],
        sitesByType: [],
        compareTo: 'PoP',
        devices: ['DESKTOP', 'MOBILE'],
        countries: []
    }
});


export const appSlice = createSlice({
    name: 'app',
    initialState: getInitialState(),
    reducers: {
        updateCurrentPage: (state, action) => {
            // console.log("@@@ UPDATE CURRENT PAGE @@@@", action.payload);
            state.currentPage = action.payload;
            setTimeout(function(){ history.push(action.payload) }, 0); // route through history to page (for some reason need the timeout or issues arrise, should circle back to this)
        },
        toggleSidebar: (state, action) => {
            state.sidebarOpen = action.payload;
        },
        lockSidebar: (state, action) => {
            state.sidebarLocked = action.payload;
        },
        toggleUserMenu: (state, action) => {
            state.userMenuOpen = action.payload;
        },
        setCurrentMenu: (state, action) => {
            state.currentMenu = action.payload
        },
        setFilter: (state, action) => {
            const { filter, value } = action.payload
            state.filters[filter] = value
        },
    }
});


export const { updateCurrentPage, toggleSidebar, lockSidebar, toggleUserMenu, setFilter, setCurrentMenu } = appSlice.actions;
export default appSlice.reducer;
